var _class, _HelpPanelItem;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import { Category, HelpAction } from "../../../../Core/AnalyticEvents/analyticEvents";
import { isJsonString } from "../../../../Core/Json";
import Icon, { StyledIcon } from "../../../../Styled/Icon";
import Text from "../../../../Styled/Text";
import { applyTranslationIfExists } from "../../../../Language/languageHelpers";
import HelpVideoPanel from "./HelpVideoPanel";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let HelpPanelItem = observer(_class = (_HelpPanelItem = class HelpPanelItem extends Component {
  render() {
    const {
      i18n
    } = this.props;
    const itemSelected = this.props.viewState.selectedHelpMenuItem === this.props.content.itemName;

    // `content.icon` is user defined and can possibly force the UI to lookup a
    // nonexistant icon.
    const title = isJsonString(this.props.content.title) ? applyTranslationIfExists(this.props.content.title, i18n) : "";
    const paneMode = this.props.content.paneMode;
    const opensInPanel = paneMode !== "externalLink";
    const iconGlyph = opensInPanel ? Icon.GLYPHS.right : Icon.GLYPHS.externalLink;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(MenuButton, {
        isSelected: itemSelected,
        role: paneMode === "externalLink" ? "link" : undefined,
        onClick: () => {
          var _this$props$terria$an;
          (_this$props$terria$an = this.props.terria.analytics) === null || _this$props$terria$an === void 0 || _this$props$terria$an.logEvent(Category.help, HelpAction.itemSelected, title);
          if (opensInPanel) {
            this.props.viewState.selectHelpMenuItem(this.props.content.itemName);
          } else if (paneMode === "externalLink" && this.props.content.url) {
            window.open(this.props.content.url);
          }
        },
        children: [/*#__PURE__*/_jsx(MenuItemText, {
          children: title
        }), /*#__PURE__*/_jsx(StyledIcon, {
          styledWidth: "12px",
          fillColor: this.props.theme.textLightDimmed,
          glyph: iconGlyph
        })]
      }), opensInPanel && /*#__PURE__*/_jsx(HelpVideoPanel, {
        terria: this.props.terria,
        viewState: this.props.viewState,
        content: this.props.content,
        itemString: this.props.content.itemName,
        paneMode: this.props.content.paneMode,
        markdownContent: this.props.content.markdownText,
        videoUrl: isJsonString(this.props.content.videoUrl) ? applyTranslationIfExists(this.props.content.videoUrl, i18n) : undefined,
        placeholderImage: isJsonString(this.props.content.placeholderImage) ? applyTranslationIfExists(this.props.content.placeholderImage, i18n) : undefined,
        videoCoverImageOpacity: this.props.content.videoCoverImageOpacity
      })]
    });
  }
}, _defineProperty(_HelpPanelItem, "displayName", "HelpPanelItem"), _defineProperty(_HelpPanelItem, "propTypes", {
  terria: PropTypes.object.isRequired,
  viewState: PropTypes.object.isRequired,
  content: PropTypes.object.isRequired,
  theme: PropTypes.object,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired
}), _HelpPanelItem)) || _class;
const MenuButton = styled.button.withConfig({
  displayName: "HelpPanelItem__MenuButton",
  componentId: "sc-1f0fydn-0"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;height:100%;padding:16px 0;border:0;border-bottom:1px solid #ddd;background:transparent;&:hover{color:", ";& ", "{fill:", ";}}color:", ";& ", "{fill:", ";}"], p => p.theme.textBlack, StyledIcon, p => p.theme.textBlack, p => p.isSelected ? p.theme.textBlack : p.theme.textDark, StyledIcon, p => p.isSelected ? p.theme.textBlack : p.theme.textDark);
const MenuItemText = styled(Text).attrs({
  semiBold: true,
  large: true
}).withConfig({
  displayName: "HelpPanelItem__MenuItemText",
  componentId: "sc-1f0fydn-1"
})(["padding-right:25px;padding-left:5px;text-align:left;"]);
export default withTranslation()(withTheme(HelpPanelItem));